import { IonText, useIonModal } from '@ionic/react';
import { Header } from '../components/Header.js';
import { QuirkIonContent } from '../components/QuirkIonContent.js';
import { SelectCommunity } from '../components/SelectCommunity.js';
import { useBackendDomain } from '../hooks/useBackendDomain.js';
import { Confirmation } from './Confirmation.js';
import { QuirkCommunity } from 'model';
import { useDispatch, useSelector } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { LoginState, fetchCommunities, logout } from '../state/loginSlice.js';
import { useEffect, useState } from 'react';
import { RootState } from '../App.js';
import { IconButton } from '../components/IconButton.js';
import { IconArrowBack } from '../components/QuirkIcons/index.js';
import { useHistory } from 'react-router';
import { QuirkIonPage } from '../components/QuirkIonPage.js';

export function SelectCommunityPage() {
	const [domain, setDomain] = useBackendDomain();
	const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
	const [selected, setSelected] = useState<QuirkCommunity | undefined>(undefined);
	const state: LoginState = useSelector<RootState, LoginState>(state => state.login);
	const history = useHistory();

	useEffect(() => {
		dispatch(fetchCommunities());
	}, [dispatch]);

	const [present, dismiss] = useIonModal(Confirmation, {
		onDismiss: () => {
			dismiss();
		},
		action: async () => {
			dismiss();
			if (selected) {
				await setDomain(selected.hostname);
				dispatch(logout());
			}
		},
		actionLabel: 'Switch',
		dismissLabel: 'Cancel',
		content: (
			<>
				<h4>Are you sure you want to switch communities?</h4>
				<IonText>
					Switching communities will log you out of your current community. You will then need to login to the
					selected community.
				</IonText>
			</>
		)
	});
	const onSelectInstance = async (community: QuirkCommunity) => {
		setSelected(community);
		if (domain) {
			present();
		} else {
			await setDomain(community.hostname);
			dispatch(logout());
		}
	};
	return (
		<QuirkIonPage allowLoggedOut roles={['user', 'anonymous']}>
			<Header
				title="Find your Community"
				left={domain ? <IconButton icon={<IconArrowBack />} onClick={() => history.goBack()} /> : undefined}
			/>
			<QuirkIonContent scroll={false}>
				<SelectCommunity domain={domain} onChange={onSelectInstance} communities={state.communities} />
			</QuirkIonContent>
		</QuirkIonPage>
	);
}
